import { ISettingsGetter } from '@wix/tpa-settings';
import settingsParams from '../../components/BookOnline/settingsParams';
import {
  BOOKINGS_MAIN_PAGE_EDITOR_X_PRESET_ID,
  BOOKINGS_MAIN_PAGE_PRESET_ID,
  CLASSIC_EDITOR_X_PRESET_ID,
  CLASSIC_PRESET_ID,
  GRID_EDITOR_X_PRESET_ID,
  GRID_PRESET_ID,
  OVERLAPPING_EDITOR_X_PRESET_ID,
  OVERLAPPING_PRESET_ID,
  SINGLE_SERVICE_EDITOR_X_PRESET_ID,
  SINGLE_SERVICE_PRESET_ID,
  STRIP_EDITOR_X_PRESET_ID,
  STRIP_PRESET_ID,
} from '../../consts';
import {
  ServiceListLayoutOptions,
  ServiceListLayoutOptionsNumber,
} from '../../types/types';

const presetsIds = [
  CLASSIC_PRESET_ID,
  OVERLAPPING_PRESET_ID,
  STRIP_PRESET_ID,
  GRID_PRESET_ID,
  BOOKINGS_MAIN_PAGE_PRESET_ID,
  SINGLE_SERVICE_PRESET_ID,
  CLASSIC_EDITOR_X_PRESET_ID,
  OVERLAPPING_EDITOR_X_PRESET_ID,
  STRIP_EDITOR_X_PRESET_ID,
  GRID_EDITOR_X_PRESET_ID,
  BOOKINGS_MAIN_PAGE_EDITOR_X_PRESET_ID,
  SINGLE_SERVICE_EDITOR_X_PRESET_ID,
] as const;

export const mapPrestIdToNumber = (
  presetId: (typeof presetsIds)[number],
): number => presetsIds.indexOf(presetId);

export const isTabsDisplaySelected = (settings: {
  get: ISettingsGetter;
}): boolean =>
  settings.get(settingsParams.isListFilterVisible) &&
  !settings.get(settingsParams.isMenuVisible);

export const isMenuDisplaySelected = (settings: {
  get: ISettingsGetter;
}): boolean =>
  settings.get(settingsParams.isMenuVisible) &&
  settings.get(settingsParams.isListFilterVisible);

export const mapNumberToPresetId = (num: number) => presetsIds[num];

export const mapNumberToServiceListLayoutOption = (num: number) => {
  switch (num) {
    case ServiceListLayoutOptionsNumber.CLASSIC:
      return ServiceListLayoutOptions.CLASSIC;
    case ServiceListLayoutOptionsNumber.OVERLAPPING:
      return ServiceListLayoutOptions.OVERLAPPING;
    case ServiceListLayoutOptionsNumber.STRIP:
      return ServiceListLayoutOptions.STRIP;
    case ServiceListLayoutOptionsNumber.GRID:
      return ServiceListLayoutOptions.GRID;
    case ServiceListLayoutOptionsNumber.MOBILE:
      return ServiceListLayoutOptions.MOBILE;
  }
};

export const mapServiceListLayoutOptionToNumber = (
  layout: ServiceListLayoutOptions,
) => {
  switch (layout) {
    case ServiceListLayoutOptions.CLASSIC:
      return ServiceListLayoutOptionsNumber.CLASSIC;
    case ServiceListLayoutOptions.OVERLAPPING:
      return ServiceListLayoutOptionsNumber.OVERLAPPING;
    case ServiceListLayoutOptions.STRIP:
      return ServiceListLayoutOptionsNumber.STRIP;
    case ServiceListLayoutOptions.GRID:
      return ServiceListLayoutOptionsNumber.GRID;
    case ServiceListLayoutOptions.MOBILE:
      return ServiceListLayoutOptionsNumber.MOBILE;
  }
};
